import { atom, DefaultValue, selector } from "recoil";

export const extensionManagementState = atom({
    key: 'extensionManagement',
    default: {
        raFetchedData: null, // serverData
        extensionDays: null,
        dmsTimeFrames: null
    }
});

export const extensionManagementRaFetchedDataState = selector<any>({
    key: 'extensionManagementRaFetchedData',
    get: ({ get }) => get(extensionManagementState).raFetchedData,
    set: ({ set, get }, newValue) => {
        set(extensionManagementState, {
            ...get(extensionManagementState),
            raFetchedData: newValue instanceof DefaultValue ? get(extensionManagementState).raFetchedData : newValue
        })
    }
});

export const extensionDaysState = selector<any>({
    key: 'extensionDays',
    get: ({ get }) => get(extensionManagementState).extensionDays,
    set: ({ set, get }, newValue) => {
        set(extensionManagementState, {
            ...get(extensionManagementState),
            extensionDays: newValue instanceof DefaultValue ? get(extensionManagementState).extensionDays : newValue
        })
    }
});

export const dmsTimeFramesState = selector<any>({
    key: 'dmsTimeFrames',
    get: ({ get }) => get(extensionManagementState).dmsTimeFrames,
    set: ({ set, get }, newValue) => {
        set(extensionManagementState, {
            ...get(extensionManagementState),
            dmsTimeFrames: newValue instanceof DefaultValue ? get(extensionManagementState).dmsTimeFrames : newValue
        })
    }
});